import "./ReturnAfterHours.css";

export function ReturnAfterHours(): JSX.Element {
    return (
        <div className="ReturnAfterHours">
            <h3 id="returnafterhours">Return After Hours</h3>
            <p>Do you need to return your car when our offices are closed? You can do it without problems with the key
                box service that allows you to drop off your car leaving the keys in a special box.</p>
        </div>
    );
}
